export const COMPANY_DATA_SCOPE_KEY = 'crm_company_data_scope';
export const COMPANY_DATA_SCOPE_EVENT = 'company-data-scope:changed';

export type CompanyDataScopeMode = 'own' | 'network' | 'subcompany';

export type CompanyDataScope = {
  mode: CompanyDataScopeMode;
  companyId?: string | null;
};

function normalizeMode(value: unknown): CompanyDataScopeMode {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'network') return 'network';
  if (normalized === 'subcompany') return 'subcompany';
  return 'own';
}

export function normalizeCompanyDataScope(value: unknown): CompanyDataScope {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return { mode: 'own' };
  }

  const raw = value as CompanyDataScope;
  const mode = normalizeMode(raw.mode);
  const companyId = String(raw.companyId || '').trim() || null;

  if (mode !== 'subcompany') {
    return { mode };
  }

  if (!companyId) {
    return { mode: 'own' };
  }

  return {
    mode,
    companyId
  };
}

export function getStoredCompanyDataScope(): CompanyDataScope {
  if (typeof window === 'undefined') {
    return { mode: 'own' };
  }

  const raw = window.localStorage.getItem(COMPANY_DATA_SCOPE_KEY);
  if (!raw) {
    return { mode: 'own' };
  }

  try {
    return normalizeCompanyDataScope(JSON.parse(raw));
  } catch {
    return { mode: 'own' };
  }
}

export function setStoredCompanyDataScope(nextScope: CompanyDataScope) {
  if (typeof window === 'undefined') {
    return;
  }

  const normalized = normalizeCompanyDataScope(nextScope);
  window.localStorage.setItem(COMPANY_DATA_SCOPE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new CustomEvent(COMPANY_DATA_SCOPE_EVENT, {
    detail: normalized
  }));
}

export function clearStoredCompanyDataScope() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(COMPANY_DATA_SCOPE_KEY);
  window.dispatchEvent(new CustomEvent(COMPANY_DATA_SCOPE_EVENT, {
    detail: { mode: 'own' }
  }));
}
